<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="3">
					<!--pmcId-->
					<search-input :label="getMessage_('QWCC001538')" paramKey="pmcId" @commInput="setSearchParam" :propData="searchParams.pmcId" />
				</el-col>
				<!--업체판매일 , 임시) 날짜구분-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001393')"
						paramKey="srchMm03"
						:options="companySaleList"
						:propData="searchParams.srchMm03"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!--검색날짜-->
				<el-col :span="5">
					<sf-group-wrapper :label="getMessage_('QWCC001394')">
						<el-date-picker
							v-model="searchDate1"
							@change="changeSearchSrchMm03"
							type="daterange"
							align="right"
							:start-placeholder="getMessage_('QWCC000920')"
							:end-placeholder="getMessage_('QWCC000954')"
							range-separator="~"
							format="yyyy-MM-dd"
							style="height: 38px"
						/>
					</sf-group-wrapper>
				</el-col>
				<!--연료전지사양-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001021')"
						paramKey="flclSpc"
						:options="flclSpcList"
						:propData="searchParams.flclSpc"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC001016')"
						paramKey="carTypeNm"
						@commInput="setSearchParam"
						:propData="searchParams.carTypeNm"
					></search-input>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<!--판매지역-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001019')"
						paramKey="saleRegn"
						:options="saleRegnList"
						:propData="searchParams.saleRegn"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!--차량구분-->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001015')"
						paramKey="carScn"
						:options="carScnList"
						:propData="searchParams.carScn"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!--동력유형-->
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC001018')"
						paramKey="pwrType"
						@commInput="setSearchParam"
						:propData="searchParams.pwrType"
					></search-input>
				</el-col>
				<el-col :span="3">
					<!--차량 VIN-->
					<search-input :label="getMessage_('QWCC000960')" paramKey="carVin" @commInput="setSearchParam" :propData="searchParams.carVin" />
				</el-col>
				<el-col :span="3">
					<!--승상구분-->
					<select-combo
						:label="getMessage_('QWCC001017')"
						paramKey="pacScn"
						:options="pacScnList"
						:propData="searchParams.pacScn"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<el-col :span="2">
					<search-input
						:label="getMessage_('QWCC002119')"
						paramKey="licensePlate"
						@commInput="setSearchParam"
						:propData="searchParams.licensePlate"
					></search-input>
				</el-col>
				<!--생산법인-->
				<!-- <el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001546')"
						paramKey="customPrCor"
						:options="customPrCorList"
						:propData="searchParams.customPrCor"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>-->
				<!--생산공장-->
				<!-- <el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001540')"
						paramKey="plntCd"
						:options="plntCdList"
						:propData="searchParams.plntCd"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>  -->
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/qlty/CarSale/store/helpers';
import SearchInput from '@qms/Components/SearchInput';
import SelectCombo from '@qms/Components/SelectCombo';

export default {
	props: {
		scrId: { type: String, default: '' },
		pStartDt: { type: String, default: '' },
		pEndDt: { type: String, default: '' },
		pState1: { type: String, default: '' },
		pState2: { type: String, default: '' },
		pState3: { type: String, default: '' },
		pState4: { type: String, default: '' },
		pState5: { type: String, default: '' },
		pState6: { type: String, default: '' },
		pState10: { type: String, default: '' }
	},
	/*
	data() {
		let fromDate = this.$moment().startOf('month').format('YYYY-MM-DD');
		let toDate = this.$moment().endOf('month').format('YYYY-MM-DD');
		return {
			searchDate1: [new Date(fromDate), new Date(toDate)],
			fromDate: fromDate,
			toDate: toDate
		};
	}*/
	data() {
		return {
			searchDate1: ['', '']
		};
	},
	components: { SearchInput, SelectCombo },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		setSearchParam(param) {
			this.setSearchParam_(param);
		},
		searchList() {
			this.setSearchParam_({ key: 'idxScn', value: '' });
			this.$sf_toggleLoading(true);
			this.getCarSaleList_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		changeSearchSrchMm03(data) {
			let from;
			let to;
			if (data) {
				from = this.$moment(data[0]).format('YYYY-MM-DD');
				to = this.$moment(data[1]).format('YYYY-MM-DD');
			}

			//this.searchDate1 = [from, to];
			this.selectDate1({ from, to });
		}
	},
	async created() {
		try {
			//state안에 초기화 되어있는 값을 개터스 함수로 꺼내서 셋팅한다.
			await this.postSearchSelectList_();
			//console.log('searchDate1 전', this.searchDate1);
			//console.log('pStartDt', this.pStartDt);
			//console.log('pEndDt', this.pEndDt);
			//console.log('pState6', this.pState6);
			//console.log('pState10', this.pState10);
			

			/* 그래프 그리드 연결 파라미터 준비 */
			let pStartDt = this.pStartDt || '';
			let pEndDt = this.pEndDt || '';
			let pState1 = this.pState1 || ''; // 차량구분
			let pState2 = this.pState2 || ''; // 승상구분
			let pState3 = this.pState3 || ''; // 연료전지사양
			let pState4 = this.pState4 || ''; // 판매지역
			let pState5 = this.pState5 || '';
			let pState6 = this.pState6 || ''; // 날짜구분
			let pState10 = this.pState10 || ''; // 날짜구분

			//파라미터 세팅 전 초기화
			if (pStartDt && pEndDt) {
				//let pStartDt11 = this.$moment(pStartDt).format('YYYY-MM-DD')
				let pStartDt1 = '';
				let pEndDt2 = '';
				if(pState6=='M3'){
					if(pStartDt.length==8){
						let pStartDt11 = this.$moment(pStartDt).format('YYYY-MM-DD').substr(0,4)-0;
						pStartDt1 = (pStartDt11 -1)+'-10-01';
				        pEndDt2 = pStartDt11 + '-9-30';
					}else{
						let ss = this.$moment(pStartDt.slice(0,6)).format('YYYYMM');
						//let pStartDt12 = this.$moment(ss).format('YYYYMM');
						let pStartDt13 = this.$moment(ss).subtract(3, 'M').format('YYYYMM'); //수동테스트
						pStartDt1 = this.$moment(pStartDt13+'01').startOf('month').format('YYYY-MM-DD'); //시작일자
					    pEndDt2 = this.$moment(pStartDt13+'01').endOf('month').format('YYYY-MM-DD'); //종료일자
					}
				     
				}else{
					if(pStartDt.length==8){
						let pStartDt11 = this.$moment(pStartDt).format('YYYY-MM-DD').substr(0,4)-0;
						pStartDt1 = (pStartDt11 -1)+'-01-01';
						//let pEndDt2 = this.$moment(pEndDt).format('YYYY-MM-DD');
						pEndDt2 = (pStartDt11 -1) + '-12-31';
					}else{
						let ss = this.$moment(pStartDt.slice(0,6)).format('YYYYMM');
						//let pStartDt12 = this.$moment(ss).format('YYYYMM');
						let pStartDt13 = this.$moment(ss).subtract(12, 'M').format('YYYYMM'); //수동테스트
						pStartDt1 = this.$moment(pStartDt13+'01').startOf('month').format('YYYY-MM-DD'); //시작일자
					    pEndDt2 = this.$moment(pStartDt13+'01').endOf('month').format('YYYY-MM-DD'); //종료일자
					}
				}
				this.searchDate1 = [pStartDt1, pEndDt2];

				//console.log('pStartDt1', pStartDt1);
				//console.log('pEndDt2', pEndDt2);

				this.setSearchParam_({ key: 'strtMm01', value: pStartDt1 }); // 검색시작일자
				this.setSearchParam_({ key: 'endMm01', value: pEndDt2 }); // 검색종료일자

				this.setSearchParam_({ key: 'carScn', value: pState1 }); //차량구분
				this.setSearchParam_({ key: 'pacScn', value: pState2 }); //승상구분
				this.setSearchParam_({ key: 'flclSpc', value: pState3 }); //연료전지사양
				this.setSearchParam_({ key: 'saleRegn', value: pState4 }); //판매지역
				this.setSearchParam_({ key: 'srchMm03', value: pState5 }); // 날짜구분
				this.setSearchParam_({ key: 'carTypeNm', value: pState10 }); // 날짜구분
				this.setSearchParam_({ key: 'idxScn', value: pState6 });

				//console.log('searchDate1 후', this.searchDate1);
			} 
			else {
				// console.log('~~~~~~~~~~~~~~~~~~메뉴에서진입');
				// let fromDate = this.$moment().startOf('month').format('YYYY-MM-DD');
				// let toDate = this.$moment().endOf('month').format('YYYY-MM-DD');

				// console.log('~~~~~~~~~~~~~~~~~~fromDate', fromDate);
				// console.log('~~~~~~~~~~~~~~~~~~toDate', toDate);

				// this.searchDate1 = [fromDate, toDate];

				// this.setSearchParam_({ key: 'strtMm01', value: fromDate }); // 확정 협력사 분담율
				// this.setSearchParam_({ key: 'endMm01', value: toDate }); // 확정 협력사 분담율
				this.setSearchParam_({ key: 'idxScn', value: '' });
			}

			await this.getCarSaleList_();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	}
};
</script>

<style></style>
